import Vue from 'vue';
import VueRouter from 'vue-router';

import authGuard from '../auth/authGuard';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "ratings" */ '@/views/Ratings.vue'),
    meta: {
      requiresLogin: true,
      requiredRoles: ['admin', 'analyst', 'farm-team', 'adp'],
      excludedRoles: ['contractor-usm-admin'],
      redirectOnUnauthorized: '/tickeradmin/listcompanies',
    },
  },
  {
    path: '/company',
    name: 'company',
    component: () => import(/* webpackChunkName: "company" */ '@/views/Company.vue'),
    props: route => ({
      query: route.query.company_id,
    }),
    meta: {
      requiresLogin: true,
      excludedRoles: ['contractor-usm-admin'],
    },
  },
  {
    path: '/analyst',
    name: 'analyst',
    component: () => import(/* webpackChunkName: "analyst" */ '@/views/Analyst.vue'),
    props: route => ({
      query: route.query.analyst_id,
    }),
    meta: {
      requiresLogin: true,
      requiredRoles: ['admin', 'analyst', 'farm-team', 'adp'],
      excludedRoles: ['contractor-usm-admin'],
    },
  },
  {
    path: '/bbn',
    name: 'best-buys-now',
    component: () => import(/* webpackChunkName: "bbn" */ '@/views/BestBuysNow.vue'),
    meta: {
      requiresLogin: true,
      requiredRoles: ['admin', 'vote', 'vote-admin'],
      excludedRoles: ['contractor-usm-admin'],
    },
  },
  {
    path: '/tickeradmin/listcompanies',
    name: 'ticker-admin-list-companies',
    component: () => import(/* webpackChunkName: "tickeradmin-list-companies" */ '@/views/ticker_admin/TickerAdminListCompanies.vue'),
    meta: {
      requiresLogin: true,
    },
  },
  {
    path: '/cryptoadmin/listcryptos',
    name: 'crypto-admin-list-cryptos',
    component: () => import(/* webpackChunkName: "tickeradmin-list-companies" */ '@/views/crypto_admin/CryptoAdminListCryptos.vue'),
    meta: {
      requiresLogin: true,
    },
  },
  {
    path: '/tickeradmin/listservices',
    name: 'ticker-admin-list-services',
    component: () => import(/* webpackChunkName: "tickeradmin-list-services" */ '@/views/ticker_admin/TickerAdminListServices.vue'),
    meta: {
      requiresLogin: true,
      excludedRoles: ['contractor-usm-admin'],
    },
  },
  {
    path: '/tickeradmin/listoptions',
    name: 'ticker-admin-list-options',
    component: () => import(/* webpackChunkName: "tickeradmin-list-options" */ '@/views/ticker_admin/TickerAdminListOptions.vue'),
    meta: {
      requiresLogin: true,
    },
  },
  {
    path: '/tickeradmin/editcompany',
    name: 'ticker-admin-edit-company',
    component: () => import(/* webpackChunkName: "tickeradmineditcompany" */ '@/views/ticker_admin/TickerAdminEditCompany.vue'),
    props: route => ({
      query: {
        capiq: route.query.capiq,
        company_id: route.query.company_id,
      },
    }),
    meta: {
      requiresLogin: true,
    },
  },
  {
    path: '/tickeradmin/viewequity',
    name: 'ticker-admin-view-equity',
    component: () => import(/* webpackChunkName: "tickeradminviewequity" */ '@/views/ticker_admin/TickerAdminViewEquity.vue'),
    props: route => ({
      query: route.query.instrument_id,
    }),
    meta: {
      requiresLogin: true,
    },
  },
  {
    path: '/tickeradmin/viewmutualfund',
    name: 'ticker-admin-view-mutualfund',
    component: () => import(/* webpackChunkName: "tickeradminviewmutualfund" */ '@/views/ticker_admin/TickerAdminViewMutualFund.vue'),
    props: route => ({
      query: route.query.instrument_id,
    }),
    meta: {
      requiresLogin: true,
    },
  },
  {
    path: '/tickeradmin/viewcrypto',
    name: 'ticker-admin-view-crypto',
    component: () => import(/* webpackChunkName: "tickeradminviewcrypto" */ '@/views/ticker_admin/TickerAdminViewCrypto.vue'),
    props: route => ({
      query: route.query.instrument_id,
    }),
    meta: {
      requiresLogin: true,
    },
  },
  {
    path: '/tickeradmin/editequity',
    name: 'ticker-admin-edit-equity',
    component: () => import(/* webpackChunkName: "tickeradmineditequity" */ '@/views/ticker_admin/TickerAdminEditEquity.vue'),
    props: route => ({
      query: {
        instrument_id: route.query.instrument_id,
      },
    }),
    meta: {
      requiresLogin: true,
    },
  },
  {
    path: '/tickeradmin/editmutualfund',
    name: 'ticker-admin-edit-mutualfund',
    component: () => import(/* webpackChunkName: "tickeradmineditmutualfund" */ '@/views/ticker_admin/TickerAdminEditMutualFund.vue'),
    props: route => ({
      query: {
        instrument_id: route.query.instrument_id,
      },
    }),
    meta: {
      requiresLogin: true,
    },
  },
  {
    path: '/tickeradmin/viewrecommendations',
    name: 'ticker-admin-view-recommendations',
    component: () => import(/* webpackChunkName: "tickeradminviewrecommendations" */ '@/views/ticker_admin/TickerAdminViewRecommendations.vue'),
    props: route => ({
      query: {
        instrument_id: route.query.instrument_id,
        portfolio_id: route.query.portfolio_id,
      },
    }),
    meta: {
      requiresLogin: true,
      excludedRoles: ['contractor-usm-admin'],
    },
  },
  {
    path: '/tickeradmin/editrec',
    name: 'ticker-admin-edit-rec',
    component: () => import(/* webpackChunkName: "tickeradmineditrec" */ '@/views/ticker_admin/TickerAdminEditRec.vue'),
    props: route => ({
      query: route.query.recommendation_id,
    }),
    meta: {
      requiresLogin: true,
      excludedRoles: ['contractor-usm-admin'],
    },
  },
  {
    path: '/tickeradmin/addservice',
    name: 'ticker-admin-add-service',
    component: () => import(/* webpackChunkName: "tickeradminaddservice" */ '@/views/ticker_admin/TickerAdminAddService.vue'),
    meta: {
      requiresLogin: true,
      excludedRoles: ['contractor-usm-admin'],
    },
  },
  {
    path: '/tickeradmin/editservice',
    name: 'ticker-admin-edit-service',
    component: () => import(/* webpackChunkName: "tickeradmineditservice" */ '@/views/ticker_admin/TickerAdminEditService.vue'),
    props: route => ({
      query: route.query.service_id,
    }),
    meta: {
      requiresLogin: true,
      excludedRoles: ['contractor-usm-admin'],
    },
  },
  {
    path: '/tickeradmin/viewportfolio',
    name: 'ticker-admin-view-portfolio',
    component: () => import(/* webpackChunkName: "tickeradminviewportfolio" */ '@/views/ticker_admin/TickerAdminViewPortfolio.vue'),
    props: route => ({
      query: route.query.portfolio_id,
    }),
    meta: {
      requiresLogin: true,
      excludedRoles: ['contractor-usm-admin'],
    },
  },
  {
    path: '/tickeradmin/editportfolio',
    name: 'ticker-admin-edit-portfolio',
    component: () => import(/* webpackChunkName: "tickeradmineditportfolio" */ '@/views/ticker_admin/TickerAdminEditPortfolio.vue'),
    props: route => ({
      query: route.query.portfolio_id,
    }),
    meta: {
      requiresLogin: true,
      excludedRoles: ['contractor-usm-admin'],
    },
  },
  {
    path: '/tickeradmin/addportfolio',
    name: 'ticker-admin-add-portfolio',
    component: () => import(/* webpackChunkName: "tickeradminaddportfolio" */ '@/views/ticker_admin/TickerAdminAddPortfolio.vue'),
    meta: {
      requiresLogin: true,
      excludedRoles: ['contractor-usm-admin'],
    },
  },
  {
    path: '/tickeradmin/addrecommendation',
    name: 'ticker-admin-add-recommendation',
    component: () => import(/* webpackChunkName: "tickeradminaddrecommendation" */ '@/views/ticker_admin/TickerAdminAddRecommendation.vue'),
    meta: {
      requiresLogin: true,
      excludedRoles: ['contractor-usm-admin'],
    },
  },
  {
    path: '/tickeradmin/addinstrument',
    name: 'ticker-admin-add-instrument',
    component: () => import(/* webpackChunkName: "tickeradminaddinstrument" */ '@/views/ticker_admin/TickerAdminAddInstrument.vue'),
    meta: {
      requiresLogin: true,
    },
  },
  {
    path: '/tickeradmin/addcrypto',
    name: 'ticker-admin-add-crypto',
    component: () => import(/* webpackChunkName: "tickeradminaddcrypto" */ '@/views/ticker_admin/TickerAdminAddCrypto.vue'),
    meta: {
      requiresLogin: true,
    },
  },
  {
    path: '/tickeradmin/editrecquick',
    name: 'ticker-admin-edit-rec-quick',
    component: () => import(/* webpackChunkName: "tickeradmineditrecquick" */ '@/views/ticker_admin/TickerAdminEditRecQuick.vue'),
    meta: {
      requiresLogin: true,
      excludedRoles: ['contractor-usm-admin'],
    },
  },
  {
    path: '/tickeradmin/editrecmulti',
    name: 'ticker-admin-edit-rec-multi',
    component: () => import(/* webpackChunkName: "tickeradmineditrecmulti" */ '@/views/ticker_admin/TickerAdminEditRecMulti.vue'),
    meta: {
      requiresLogin: true,
      excludedRoles: ['contractor-usm-admin'],
    },
  },
  {
    path: '/tickeradmin/addoption',
    name: 'ticker-admin-add-option',
    component: () => import(/* webpackChunkName: "tickeradminaddoption" */ '@/views/ticker_admin/TickerAdminAddOption.vue'),
    meta: {
      requiresLogin: true,
    },
  },
  {
    path: '/tickeradmin/editoption',
    name: 'ticker-admin-edit-option',
    component: () => import(/* webpackChunkName: "tickeradmineditoption" */ '@/views/ticker_admin/TickerAdminEditOption.vue'),
    props: route => ({
      query: route.query.option_id,
    }),
    meta: {
      requiresLogin: true,
    },
  },
  {
    path: '/useradmin/listusers',
    name: 'user-admin-list-users',
    component: () => import(/* webpackChunkName: "useradmin-list-users" */'../views/user_admin/Users.vue'),
    meta: {
      requiresLogin: true,
      requiredRoles: ['admin', 'tickerguide-admin'],
      excludedRoles: ['contractor-usm-admin'],
    },
  },
  {
    path: '/useradmin/adduser',
    name: 'user-admin-add-user',
    component: () => import(/* webpackChunkName: "useradmin-add-user" */'@/views/user_admin/AddUser.vue'),
    meta: {
      requiresLogin: true,
      requiredRoles: ['admin', 'tickerguide-admin'],
      excludedRoles: ['contractor-usm-admin'],
    },
  },
  {
    path: '/useradmin/edituser',
    name: 'user-admin-edit-user',
    component: () => import(/* webpackChunkName: "useradmin-add-user" */'@/views/user_admin/EditUser.vue'),
    props: route => ({
      query: route.query.analyst_id,
    }),
    meta: {
      requiresLogin: true,
      requiredRoles: ['admin', 'tickerguide-admin'],
      excludedRoles: ['contractor-usm-admin'],
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
  },
  {
    path: '/loading',
    name: 'loading',
    component: () => import(/* webpackChunkName: "loading" */ '@/views/Loading.vue'),
  },
  {
    path: '*',
    name: 'notfound',
    // route level code-splitting
    // this generates a separate chunk (notfound.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "notfound" */ '@/views/NotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach(authGuard);

export default router;
